module.exports = __webpack_public_path__ + "img/technology-split-image-03.19d0ad5d.svg";